import styled from 'styled-components';
import {
    MENU_LOGO_VIEW_HEIGHT,
    SIDEBAR_WIDTH_COLLAPSE,
    SIDEBAR_WIDTH_EXPAND,
} from '@constants/numbers';

const AFTER_LOGIN_HEIGHT = MENU_LOGO_VIEW_HEIGHT + 130;
export const SidebarWrap = styled.div`
    ${({ gameDisplaying }) =>
        gameDisplaying &&
        `
        display: none;
    `}


    color: white;
    flex-grow: 1;
    box-sizing: border-box;
    background: ${({ theme }) => theme.minor};
    height: 100vh; /* Add fixed height to ensure container extends full viewport height */
    display: flex;
    flex-direction: column;
    width: ${({ isExpand }) =>
        isExpand ? `${SIDEBAR_WIDTH_EXPAND}px` : `${SIDEBAR_WIDTH_COLLAPSE}px`};
    min-width: ${({ isExpand }) =>
        isExpand ? `${SIDEBAR_WIDTH_EXPAND}px` : `${SIDEBAR_WIDTH_COLLAPSE}px`};
    max-width: ${({ isExpand }) =>
        isExpand ? `${SIDEBAR_WIDTH_EXPAND}px` : `${SIDEBAR_WIDTH_COLLAPSE}px`};
    ${({ isMobile }) =>
        isMobile &&
        `
        height: -webkit-fill-available;
    `}

    .logo-wrap {
        margin-bottom: 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        box-sizing: border-box;
        text-align: center;
        padding: ${({ isExpand }) =>
        isExpand ? '8px 0px 8px 0px' : '8px 0px 8px 0px'};
        ${({ isExpand }) =>
        !isExpand &&
        `
                display: flex; justify-content: center;
                flex-direction: column;
            `}

        > img {
            background: ${({ theme }) => theme.primary};
            width: ${({ isExpand }) => (isExpand ? '100%' : '100%')};
            height: ${({ isExpand }) => (isExpand ? 'auto' : '80px')};
        }

        .login-btn {
            cursor: pointer;
            margin-top: 16px;
            text-align: center;
            border-radius: 800px;
            background: ${({ theme }) => theme.primary};
            color: white;
            font-size: 16px;
            padding: ${({ isExpand }) =>
        isExpand ? '0.375rem 1.5rem' : '0.375rem 0.5rem'};
        }
    }

    .sidebar-items {
        /* Use flexbox approach for both mobile and non-mobile */
        flex: 1; /* Use flex to fill remaining space */
        min-height: 0; /* Allow container to shrink */
        overflow-y: auto;
        padding-bottom: 120px;
        display: flex;
        flex-direction: column;
    }

    .menu-group {
        margin-bottom: 8px;
        
        &:last-child {
            margin-bottom: 0;
        }

        &[data-group="logout"] {
            margin-top: auto;
            margin-bottom: 8px;
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            padding-top: 8px;
        }
    }

    .group-label {
        font-size: 10px;
        font-weight: 500;
        color: #888888;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 2px 12px;
        margin-bottom: 2px;
        text-align: left;
        
        &:empty {
            display: none;
            margin-bottom: 0;
            padding: 0;
        }
    }

    .group-items {
        margin: 0;
        padding: 0;
    }
`;
